import React from 'react'
import { Outlet, Link as RouterLink } from 'react-router-dom'

import {
  Box,
  CssBaseline,
  Toolbar,
  AppBar,
  IconButton,
  Container,
  Typography,
  Link,
} from '@mui/material'

import StikisLogoTiny from 'images/stikis_logo-img_only-small.png'
import StaticFlash from '../static/StaticFlash'
import StaticFooter from '../static/StaticFooter'
import SignOut from '../../redux/features/user/SignOut'

const classes = {
  growBox: {
    display: 'flex',
    flexGrow: 1,
  },
  helpLink: {
    margin: '0 5px 0 5px',
    cursor: 'pointer',
  },
}

// 0.6.27.13: FormLayout's chrome, but for a signed-in account that hasn't
// confirmed yet (no login at all, or mid-claim correcting a mistake) --
// found 2026-10-14 that showing the normal AuthenticatedNavigation
// (Account/Sign Out/Help) here was actively misleading: it looks like an
// ordinary signed-in account, right down to letting you click into a real
// Account page, when nothing is actually usable yet. Sign Out is the one
// link this account genuinely needs (it would otherwise have no way out
// at all -- see the no-sign-out-link bug this replaced); Account implied
// more than is true, so it stays off. Help doesn't have that problem --
// it's a static page, not tied to account state -- so 0.6.27.16 added it
// back, at your request, for this layout's other use (VerifyAccount.jsx).
export default function MigratingFormLayout() {

  return (
    <React.Fragment>
      <Box sx={
        { display: 'flex', position: 'relative', zIndex: 2}
      }>
        <CssBaseline />
        <AppBar position='relative'>
          <Toolbar>
            <IconButton
              href='/app/welcome'
              edge='start'
              aria-label='home page'
              sx={{
                paddingRight: '2px',
                color: 'white',
              }}
              size='large'
            >
              <img src={StikisLogoTiny} id='stikisLogoTiny' alt='Stikis logo' />
              <Typography
                variant='h1'
                sx={{
                  fontWeight: 900,
                  fontSize: '2rem',
                }}
              >
                stikis
              </Typography>
            </IconButton>
            <Box sx={classes.growBox}>
            </Box>
            <SignOut />
            <Link
              component={RouterLink}
              to='/help'
              sx={classes.helpLink}
              color='inherit'
            >
              Help
            </Link>
          </Toolbar>
        </AppBar>
      </Box>
      <Container component="main" maxWidth="md">
        <StaticFlash />
        <Box
          sx={{
            marginTop: 9,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Outlet />
        </Box>
      </Container>
      <StaticFooter />
    </React.Fragment>
  )
}
